import React from 'react';

const SupportIcon = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.8694 6.5C14.7985 6.5 14.7276 6.5 14.6567 6.5V6.07143C14.6567 3.57143 12.6007 1.5 10.1194 1.5H8.48881C6.00746 1.5 3.95149 3.57143 3.95149 6.07143V6.57143C3.8806 6.57143 3.8806 6.57143 3.8097 6.57143C2.95896 6.5 2.25 7.21429 2.25 8.14286V10.7857C2.25 11.6429 2.95896 12.3571 3.8097 12.3571H4.66045C5.08582 12.3571 5.3694 12.0714 5.3694 11.6429V8.14286V6.07143C5.3694 4.35714 6.78731 2.92857 8.48881 2.92857H10.1194C11.8209 2.92857 13.2388 4.35714 13.2388 6.07143V7.21429V11.5714V12.3571C13.2388 13.7143 12.1754 14.8571 10.8993 15C10.6866 14.4286 10.1903 14 9.48134 14C8.48881 14 7.99254 15 7.92164 15.6429C7.85075 15.8571 7.92164 16.0714 8.06343 16.2143C8.20522 16.3571 8.41791 16.5 8.6306 16.5H10.6157C12.8843 16.5 14.7276 14.6429 14.7276 12.3571V12.2857H14.9403C15.791 12.2857 16.5 11.5714 16.5 10.7143V8.14286C16.4291 7.21429 15.7201 6.5 14.8694 6.5Z"
      fill="#FF8A00"
    />
  </svg>
);
export default SupportIcon;
